import { Icon } from '@iconify/react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { formatAadhaar, maskAadhaar } from '../../../shared/utils/misc';

interface AadhaarNumberProps {
  value?: string | number | null;
}

/**
 * An employee's Aadhaar number, masked to its last four digits.
 *
 * The number is on screen far more often than anyone actually needs to read it - the
 * details card is open whenever an employee is looked at - so it starts hidden and is
 * revealed a person at a time, deliberately, rather than being on show by default.
 *
 * The reveal is per view and is not remembered: reopening the screen masks it again.
 */
export default function AadhaarNumber({ value }: AadhaarNumberProps) {
  const [revealed, setRevealed] = useState(false);

  if (!value) return <span className='unavailable-message'>Not Available</span>;

  return (
    <span className='row'>
      <span>{revealed ? formatAadhaar(value) : maskAadhaar(value)}</span>
      <Tooltip title={revealed ? 'Hide Aadhaar number' : 'Show Aadhaar number'}>
        <IconButton
          size='small'
          aria-label={revealed ? 'Hide Aadhaar number' : 'Show Aadhaar number'}
          onClick={() => setRevealed((shown) => !shown)}
        >
          <Icon icon={revealed ? 'mdi:eye-off-outline' : 'mdi:eye-outline'} width={18} />
        </IconButton>
      </Tooltip>
    </span>
  );
}
